import * as React from "react";
const SvgUpload = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z" }));
export default SvgUpload;
